import React from 'react';
import SEO from '../components/SEO';
import FAQSection from '../components/FAQSection';

const FAQ = () => {
  return (
    <>
      <SEO pathname="/faq" />
      <div className="pt-20">
        <FAQSection />
      </div>
    </>
  );
};

export default FAQ;
